import React from "react";
import Grid from "@material-ui/core/Grid";

import styles from "./markdown.module.css";

export const initial = () => ({});

const FormattedInput = (props: any) =>
  <Grid
    item
    sm={12}
    className={styles.markdown}
    dangerouslySetInnerHTML={{ __html: props.data.content }}
  />;

FormattedInput.initial = initial;

export default FormattedInput;
